export default "https://cdn-static.gokick.com/assets/b96dd49a95534624185e45ca053b90dd739d9b4e/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";